import styled, { css, keyframes } from "styled-components";
import { colors } from "healthex-common/colors";
const tapPulse = keyframes `
    0% { transform: translateY(0) scale(1); }
    50% { transform: translateY(0) scale(0.88); }
    100% { transform: translateY(0) scale(1); }
`;
const BOTTOM_OFFSET = 24;
export const ArrowButton = styled.button `
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom, 0px) + ${BOTTOM_OFFSET}px);
    left: 50%;
    margin-left: -22px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    padding: 0;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(13, 39, 64, 0.08);
    pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
    opacity: ${(props) => (props.$visible ? 1 : 0)};
    transform: translateY(${(props) => (props.$visible ? "0" : "8px")});
    transition: opacity 250ms ease-out, transform 250ms ease-out;

    ${(props) => props.$tapped &&
    css `
            animation: ${tapPulse} 200ms ease-out;
        `}

    &:active {
        transform: translateY(0) scale(0.92);
    }

    svg {
        color: ${colors.navy_main};
        width: 24px;
        height: 24px;
    }
`;
